import { render } from "./SamplesTable.vue?vue&type=template&id=ed85e694"
import script from "./SamplesTable.vue?vue&type=script&lang=js"
export * from "./SamplesTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/reps.mlelectronics.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__